import React, { Component } from 'react';
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
} from 'recharts';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import IconSquareCustom from '../../assets/icons/IconSquareCustom';

class TicketTrendVolumeChart extends Component {
    legendTrenVolume = props => {
        const { payload } = props;
        return (
            <div className="flex text-base font-medium text-nexcareblue1 justify-center pb-3">
                {
                    payload.map((entry, index) => (
                        <div key={`item-${index}`} className="flex items-center">
                            <IconSquareCustom squareColor={entry.color} />
                            <div className="px-3">{entry.value}</div>
                        </div>
                    ))
                }
            </div>
        );
    }

    render() {
        return (
            <>
                {/* Tren Volume Ticket */}
                <div id="btntrenvolume" className="rounded-md shadow-lg relative col-span-7 bg-white cursor-pointer" onClick={this.props.handlePopupTicketTrenVolume}>
                    <div className="text-nexcareblue1 p-3">
                        <div className="pt-3">
                            {
                                this.props.loading
                                    ? <Skeleton height={20} width={200} />
                                    : <p className="text-xl font-bold">Tren Volume Tiket</p>
                            }
                        </div>
                    </div>

                    {
                        this.props.loading
                            ? <div className="p-3"><Skeleton height={300} /></div>
                            : <div>
                                {
                                    this.props.data.length > 0
                                        ? <div className="w-full h-72">
                                            <ResponsiveContainer width="100%" height="100%">
                                                <BarChart
                                                    data={this.props.data}
                                                    margin={{
                                                        top: 5,
                                                        bottom: 5,
                                                        left: 0,
                                                        right: 30,
                                                    }}
                                                >
                                                    <CartesianGrid strokeDasharray="1 1" />
                                                    <XAxis dataKey="name" tick={{ stroke: "rgba(30, 64, 175, 1)", fontWeight: "1" }} />
                                                    <YAxis />
                                                    <Tooltip />
                                                    <Bar dataKey="ND6" fill="#F15A29" />
                                                    <Bar dataKey="Nexmile" fill="#FFCB09" />
                                                    <Bar dataKey="NexFin" fill="#AB3291" />
                                                    <Bar dataKey="GroMart" fill="#2E90FC" />
                                                    <Bar dataKey="NexChief" fill="#9DEFDC" />
                                                    <Bar dataKey="NexPos" fill="#FC8C03" />
                                                    <Legend content={this.legendTrenVolume} />
                                                </BarChart>
                                            </ResponsiveContainer>
                                        </div>
                                        : <div className="flex justify-center items-center text-lg font-medium h-72">
                                            <p className="text-darkgrey">Tidak ada data</p>
                                        </div>
                                }
                            </div>
                    }
                </div>
            </>
        );
    }
}

export default TicketTrendVolumeChart;